export const Category: string[] = [
  "Electronics",
  "Fashion",
  "Stationary",
  "Decor",

  "Grocery",
  "Personal Care",
  "Medical",
  "Travel",
  "Software",
  "Fitness",
  "HardWare",
  "Stall",
  "Fast-Food",
  "Restaurant",
  "Pub-Bar",
  "Hotel",
  "Telecom",
  "Others",
];
